import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { QuillModule } from 'ngx-quill';
import {
  DropdownModule,
  InputTextModule,
  InputNumberModule,
  RadioButtonModule,
  FileUploadModule,
  CheckboxModule,
  TooltipModule,
  ButtonModule,
  InputSwitchModule,
  InputTextareaModule,
  CalendarModule,
  ProgressSpinnerModule,
  InputMaskModule,
} from 'primeng';
import { EproducerUnitFormElementComponent } from './components/eproducer-unit-form-element/eproducer-unit-form-element.component';
import { PersonalDataService } from '../jurisdiction/personal-data/personal-data.service';
import { EnvironmentService } from '../services/environment.service';
import { SharedModule } from '../+shared/shared.module';
import { NetzTranslationLoader } from '../services/netz-translation-loader';
import { PowerPlantProtectionComponent } from './components/sections/power-plant-protection/power-plant-protection.component';
import { FeedInControllabilityComponent } from './components/sections/feed-in-controllability/feed-in-controllability.component';
import { DocumentsFormComponent } from './components/documents-form/documents-form.component';
import { CommentSectionComponent } from './components/comment-section/comment-section.component';
import { PhotovoltaicsDataComponent } from './components/sections/photovoltaics-data/photovoltaics-data.component';
import { EproducerDataComponent } from './components/sections/eproducer-data/eproducer-data.component';
import { StorageDataComponent } from './components/sections/storage-data/storage-data.component';
import { FeedInTypeComponent } from './components/sections/feed-in-type/feed-in-type.component';
import { MeasurementConceptComponent } from './components/sections/measurement-concept/measurement-concept.component';
import { MeterOperationComponent } from './components/sections/meter-operation/meter-operation.component';

@NgModule({
  declarations: [
    EproducerUnitFormElementComponent,
    PowerPlantProtectionComponent,
    FeedInControllabilityComponent,
    DocumentsFormComponent,
    CommentSectionComponent,
    PhotovoltaicsDataComponent,
    EproducerDataComponent,
    StorageDataComponent,
    FeedInTypeComponent,
    MeasurementConceptComponent,
    MeterOperationComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule,
    DropdownModule,
    InputTextModule,
    InputNumberModule,
    RadioButtonModule,
    FileUploadModule,
    CheckboxModule,
    TooltipModule,
    ButtonModule,
    InputSwitchModule,
    InputTextareaModule,
    CalendarModule,
    QuillModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: NetzTranslationLoader,
        deps: [HttpClient, EnvironmentService],
      },
    }),
    ProgressSpinnerModule,
    InputMaskModule,
  ],
  providers: [EnvironmentService, PersonalDataService],
  exports: [
    EproducerUnitFormElementComponent,
    PowerPlantProtectionComponent,
    FeedInControllabilityComponent,
    DocumentsFormComponent,
    CommentSectionComponent,
    PhotovoltaicsDataComponent,
    EproducerDataComponent,
    StorageDataComponent,
    FeedInTypeComponent,
    MeasurementConceptComponent,
    MeterOperationComponent,
  ],
})
export class GridApplicationSharedModule {}
